import request from '@/config/axios'

export interface HotelCouponTemplateVO {
  id?: string | number
  name: string
  description?: string
  issuerType: 'PLATFORM' | 'MERCHANT'
  benefitBearer?: 'PLATFORM' | 'MERCHANT' | 'SPLIT'
  commissionBaseType?: 'GROSS' | 'AFTER_DISCOUNT' | 'MERCHANT_RECEIVABLE'
  shopId?: string | number
  status: number
  takeType: number
  totalCount: number
  takeCount?: number
  perUserLimit: number
  useThreshold: number
  discountType: number
  discountPrice?: number
  discountPercent?: number
  discountLimitPrice?: number
  validStartTime: string | number
  validEndTime: string | number
  createTime?: string
}

export interface HotelCouponRecordVO {
  id?: string | number
  templateId?: string | number
  name: string
  issuerType: 'PLATFORM' | 'MERCHANT'
  benefitBearer?: 'PLATFORM' | 'MERCHANT' | 'SPLIT'
  commissionBaseType?: 'GROSS' | 'AFTER_DISCOUNT' | 'MERCHANT_RECEIVABLE'
  shopId?: string | number
  userId: string | number
  status: number
  takeType: number
  useThreshold: number
  discountType: number
  discountPrice?: number
  discountPercent?: number
  discountLimitPrice?: number
  validStartTime?: string | number
  validEndTime?: string | number
  receiveTime?: string
  useOrderId?: string | number
  useTime?: string
}

const withHotelScope = (params: any = {}) => {
  const scope = new URLSearchParams(window.location.search).get('hotelScope')
  return scope ? { ...params, hotelScope: scope } : params
}

export const getCouponTemplatePage = (params: any) => {
  return request.get({ url: '/hotel/coupon/template/page', params: withHotelScope(params) })
}

export const getCouponTemplate = (id: string | number) => {
  return request.get({ url: '/hotel/coupon/template/get?id=' + id })
}

export const createCouponTemplate = (data: HotelCouponTemplateVO) => {
  return request.post({ url: '/hotel/coupon/template/create', data })
}

export const updateCouponTemplate = (data: HotelCouponTemplateVO) => {
  return request.put({ url: '/hotel/coupon/template/update', data })
}

export const deleteCouponTemplate = (id: string | number) => {
  return request.delete({ url: '/hotel/coupon/template/delete?id=' + id })
}

export const sendCoupon = (data: {
  templateId: string | number
  userIds: Array<string | number>
}) => {
  return request.post({ url: '/hotel/coupon/send', data })
}

export const getCouponRecordPage = (params: any) => {
  return request.get({ url: '/hotel/coupon/record/page', params: withHotelScope(params) })
}
